import React from 'react'
import styles from './ChatView.module.css'
import Button from '../UI/Button'
import { MdClose } from "react-icons/md";
import { convertFirestoreTimeStampToDateObject } from '../../Config';

const ChatView = ({ data, onClose, onMarkComplete }) => {

    const convertedTimeStamp = convertFirestoreTimeStampToDateObject(data.timeStamp);
    const dateString = convertedTimeStamp
        ? convertedTimeStamp.toLocaleDateString() + " " + convertedTimeStamp.toLocaleTimeString()
        : "-"

    console.log("data", data)

    return (
        <div className={styles.chat_details_window}>
            <div className={styles.top_control}>
                <span className={styles.close} onClick={onClose}> <MdClose className={styles.icon} /> Close</span>
                <Button text={data.admin.status === 2 ? "Mark as new" : "Mark as complete"}
                    wrapperClassName={styles.mark_complete}
                    onClick={() => onMarkComplete(data.chatUID)}
                    wrapperStyles={data.admin.status === 2 ? { backgroundColor: '#815ECC' } : {}} />
            </div>
            <div className={styles.chat_messages}>
                <span className={styles.title}>Chat transcript</span>
                <div className={styles.messages_wrapper}>
                    {data.messages.map((message, key) => {
                        return (
                            <div key={key} className={`${styles.message} ${message.role === "user" ? styles.user : ''}`}>
                                <span>{message.role === "user" ? "Customer" : "Agent"}</span>
                                <span>{message.content}</span>
                            </div>
                        )
                    })}
                </div>

            </div>
            <div className={styles.details_view}>
                <span className={styles.title}>Details</span>
                <div className={styles.details_wrapper}>
                    {data.timeStamp && <div className={styles.entry}>
                        <span>Date</span>
                        <span>{dateString}</span>
                    </div>}
                    {Object.entries(data?.collectedData || {}).map(([key, value], idx) => {
                        return (
                            <div className={styles.entry} key={idx}>
                                <span>{key}</span>
                                <span>{`${value}`}</span>
                            </div>
                        )
                    })}
                    {data.chatUsage.windowUrl && <div className={styles.entry}>
                        <span>URL</span>
                        <span>{data.chatUsage.windowUrl}</span>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default ChatView